var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("appStore.visibility"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-content" },
      [
        _c("p", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.$t("appStore.visibilityDescription"))),
        ]),
        _vm._v(" "),
        _c(
          "a-form-item",
          { attrs: { label: _vm.$t("appStore.visibleToUsers") } },
          [
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  mode: "multiple",
                  placeholder: _vm.$t("appStore.selectUsers"),
                },
                model: {
                  value: _vm.localChannel.visibility.users,
                  callback: function ($$v) {
                    _vm.$set(_vm.localChannel.visibility, "users", $$v)
                  },
                  expression: "localChannel.visibility.users",
                },
              },
              _vm._l(_vm.users, function (user) {
                return _c(
                  "a-select-option",
                  { key: user._id, attrs: { value: user._id } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(user.fullName) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-form-item",
          { attrs: { label: _vm.$t("appStore.visibleToDepartments") } },
          [
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  mode: "multiple",
                  placeholder: _vm.$t("appStore.selectDepartments"),
                },
                model: {
                  value: _vm.localChannel.visibility.departments,
                  callback: function ($$v) {
                    _vm.$set(_vm.localChannel.visibility, "departments", $$v)
                  },
                  expression: "localChannel.visibility.departments",
                },
              },
              _vm._l(_vm.departments, function (dept) {
                return _c(
                  "a-select-option",
                  { key: dept._id, attrs: { value: dept._id } },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(dept.name) +
                        "\n                "
                    ),
                  ]
                )
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-actions" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.saving },
                on: { click: _vm.save },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("appStore.save")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }